<template>

	<section>

		<div class="columns">

			<div class="column is-half-desktop">

				<b-field horizontal label="Status">

		            <b-select placeholder="Select a status" v-model="contract.status" expanded>

		                <option value="1">Active</option>

		                <option value="0">Inactive</option>

		            </b-select>

		        </b-field>

				<b-field horizontal label="Contractor">

		            <b-select placeholder="Select" v-model="contract.contractor_firm_id" expanded>

						<option :value="firm.id" v-for="(firm, key) in contractors">{{ firm.name }}</option>

		            </b-select>

		        </b-field>

		        <b-field horizontal label="Name"> <b-input v-model="contract.name"></b-input> </b-field>

		        <b-field horizontal label="Code"> <b-input v-model="contract.code"></b-input> </b-field>



				<!-- <base-select
					:service="$options.contractService"
					fetch-func="listTypes"
					:value.sync="contract.type_tag_id"
					label="Contract Type"
					horizontal
				/> -->

				<base-combobox
					:service="$options.contractService"
					fetch-func="listTypes"
					:fetch-params="{
						created_by_firm_id: organization ? organization.id : undefined
					}"
					fetch-on-init
					:create-service="$options.tagService"
					create-func="store"
					:create-params="{ type: '[CONTRACT][TYPE]' }"
					label="Contract Type"
					allow-new
					horizontal
					@select="option => contract.type_tag_id = option.id"
					@add-new="option => contract.type_tag_id = option.id"
					ref="typeTagCombobox"
				/>

				<b-field label="Start Date" horizontal>
					<b-datepicker
						v-model="contract.start_date"
						icon="calendar"
						:date-formatter="dateFormatter"
					/>
				</b-field>

				<b-field label="End Date" horizontal>
					<b-datepicker
						v-model="contract.end_date"
						icon="calendar"
						:date-formatter="dateFormatter"
					/>
				</b-field>

				<b-field horizontal label="Financial Month Start Day">
					<b-input
						v-model="contract.financial_month"
						type="number"
						min="1"
						max="28"
					/>
				</b-field>

				<b-field label="Next Scheduled Maintenance Generation Date" horizontal>
					<b-datetimepicker
						v-model="contract.generate_schedule"
						icon="calendar"
						:datetime-formatter="datetimeFormatter"
						horizontal-time-picker
					/>
				</b-field>

	            <!-- <tags-input label="Tags" allow-new :values.sync="contract.selectedtags" only-type="[SYSTEM][CONTRACT][TYPE]" /> -->
				<base-tag-input
					horizontal
					:fetch-params="{ onlyType: '[SYSTEM][CONTRACT][TYPE]' }"
					:value.sync="contract.selectedtags"
					allow-new
				/>

				<b-field horizontal>
					<section>
						<b-field
							v-for="permission in permissions"
							:key="`permission_${permission.id}`"
						>
							<b-checkbox
								v-model="contract.permission_ids"
								:native-value="permission.id"
							>
								{{ permission.name }}
							</b-checkbox>
						</b-field>
					</section>
				</b-field>

				<base-select
					:service="$options.contractService"
					fetch-func="all"
					:fetch-params="{
						contractee_firm_id: $store.state.Auth.user.firmId,
						includes: 'contractor',
					}"
					label="Code Matrix Source"
					:value.sync="code_matrix_source_contract"
					message="The contract to be used as code matrix source"
					horizontal
				>
					<template #customLabel="{ option }">
						{{ `${option.contractor.name} - ${option.name}` }}
					</template>
				</base-select>

		        <div class="columns">

					<div class="column">
						<b-button type="is-default" expanded @click="$emit('update:create', false)">Back</b-button>
					</div>
					<div class="column">
						<b-button type="is-info" expanded @click="save">Create</b-button>
					</div>

				</div>

			</div>

		</div>

	</section>

</template>

<script>

import moment from "moment";

import { ContractService } from "@/services/contract.service";
import { PermissionService } from "@/services/permission.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import TagsInput from "@/components/partials/TagsInput";
import BaseTagInput from "@/components/partials/BaseTagInput";
import BaseSelect from "@/components/partials/BaseSelect";
import BaseCombobox from "@/components/partials/BaseCombobox";

export default {

	contractService: ContractService,
	tagService: TagService,

	components:{
		TagsInput,
		BaseTagInput,
		BaseSelect,
		BaseCombobox,
	},

	props: ['create', 'organization', 'contractors'],

    data() {

        return {

        	code_sets: [],

			permissions: [],

			code_matrix_source_contract: "",

        	contract: {

	        	name: '',

	        	code: '',

	        	type: '',

	        	status: '',

	        	contractee_firm_id: this.organization.id,

	        	contractor_firm_id: '',

        		// start_code_type: '',

				permission_ids: [],

	        	selectedtags: [],

				type_tag_id: null,

				start_date: new Date(),

				end_date: new Date(),

				financial_month: "",

				generate_schedule: null,
        	}

        }

    },

    computed: {

	    selectedtags() {

	    	return [];

	    }

    },

    mounted() {

    	this.$store.dispatch('routeLoading');
    	this.getRouteData().then(data => {
    		this.code_sets = data.code_sets || [];
			this.permissions = data.permissions || [];
    	})
    	.finally(err => {
    		this.$store.dispatch('routeLoading', false);
    	});
    },

    methods: {

		dateFormatter(date) {
			return moment(date).format("DD/MM/YYYY");
		},

		datetimeFormatter(datetime) {
			return moment(datetime).format("DD/MM/YYYY HH:mm");
		},

		dateParser(date) {
			return moment(date)
				.tz(moment.tz.guess())
				.format();
		},

    	getRouteData() {
    		return new Promise((resolve, reject) => {
				let data = {
					code_sets: [],
					permissions: [],
				};
    			Promise.all([
    				// this.getCodeSets(),
					this.getPermissions(),
    			])
    			.then(all => {
    				// data.code_sets = all[0];
					data.permissions = all[0];
    				resolve(data);
    			}).catch(err => {
    				reject(err);
    			});
    		});
    	},

    	getCodeSets() {
    		return ContractService.getCodeSets();
    	},

		getPermissions() {
			return PermissionService.all({ type: "contract" })
				.then(response => JsonDenormalizer.denormalize(response));
		},

    	async save() {

				// 	await ContractService.create(this.transformedData()).then(response => {

				// 		this.$emit('update:create', false)

				// });

				const contract = await ContractService.create(this.transformedData())
					.then(response => JsonDenormalizer.denormalize(response));

				if (this.code_matrix_source_contract) {
					await ContractService.copyCodeRelations(contract.id, { from_contract_id: this.code_matrix_source_contract });
				}

				this.$emit("update:create", false);

    	},

	    transformedData() {

	    	let data = Object.assign({}, this.contract);

      		data.tags = this.selectedtags.toString();

			data.start_date = data.start_date ? this.dateParser(data.start_date) : undefined;
			data.end_date = data.end_date ? this.dateParser(data.end_date) : undefined;
			data.generate_schedule = data.generate_schedule ? this.dateParser(data.generate_schedule) : undefined;

			if (data.financial_month) {
				let financial_month = moment();
				financial_month.date(this.contract.financial_month);
				financial_month.startOf("day");
				data.financial_month = this.dateParser(financial_month);
			}

      		return data;

	    },

    }

}

</script>



// WEBPACK FOOTER //
// src/components/pages/Contracts/create.vue